var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyfact"},[_c('div',{ref:"icon",attrs:{"data-slug":_vm.content.icon.slug}}),_c('h3',{staticClass:"keyfact__title h4"},[_vm._v(" "+_vm._s(_vm.content.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }